import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrganizationPage, type OrganizationSearch } from '@/features/admin';

/** Organization: reservoirs and organization admins (`?tab=admins&q=&panel=`). Platform and organization admins. */
export const Route = createFileRoute('/_authed/_app/admin/organizations/$orgId')({
  validateSearch: z.object({
    tab: z.enum(['tenants', 'admins']).optional().catch(undefined),
    q: z.string().optional().catch(undefined),
    panel: z.string().optional().catch(undefined),
  }),
  component: OrganizationRoute,
});

function OrganizationRoute() {
  const { me } = Route.useRouteContext();
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <OrganizationPage
      me={me}
      orgId={orgId}
      search={search}
      onSearchChange={(patch: Partial<OrganizationSearch>) =>
        void navigate({ search: (prev: OrganizationSearch) => ({ ...prev, ...patch }), replace: true })
      }
      onBack={() => void navigate({ to: '/admin' })}
      onOpenTenant={(tenant) => void navigate({ to: '/t/$tenantSlug', params: { tenantSlug: tenant.slug } })}
      onDeleted={() => void navigate({ to: '/admin' })}
      // the URL follows a new identifier (the old slug answers 404 now); the workspace tab keeps its place
      onRenamed={(org) =>
        void navigate({
          to: '/admin/organizations/$orgId',
          params: { orgId: org.slug },
          search: (prev: OrganizationSearch) => ({ ...prev, panel: undefined }),
          replace: true,
        })
      }
    />
  );
}
